import { render, staticRenderFns } from "./Layer.vue?vue&type=template&id=9029a1da&scoped=true"
import script from "./Layer.vue?vue&type=script&lang=js"
export * from "./Layer.vue?vue&type=script&lang=js"
import style0 from "./Layer.vue?vue&type=style&index=0&id=9029a1da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9029a1da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9029a1da')) {
      api.createRecord('9029a1da', component.options)
    } else {
      api.reload('9029a1da', component.options)
    }
    module.hot.accept("./Layer.vue?vue&type=template&id=9029a1da&scoped=true", function () {
      api.rerender('9029a1da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/player/Layer.vue"
export default component.exports